<tui-root>
  <tui-loader [overlay]="true" [showLoader]="$any(navLoading$ | async)">
    <router-outlet />
  </tui-loader>
</tui-root>
